const projectsData = [
    {
        projectName: 'Mastermind Game',
        deployedUrl: 'https://mastermind-board-game.netlify.app/',
        githubUrl: 'https://github.com/PakkiPavan/mastermind-board-game',
        TechnologiesUsed: 'React.js',
        projectImage: './projectImages/MastermindGame.JPG',
    },
    {
        projectName: 'Portfolio',
        deployedUrl: 'https://pavan-pakki.netlify.app/',
        githubUrl: 'https://github.com/PakkiPavan/portfolio',
        TechnologiesUsed: 'React.js',
        projectImage: './projectImages/Portfolio.JPG',
    },
];

// const data_projects = [
//     {
//         name: 'Youtube Clone',
//         image: './Youtube.JPG',
//         deployed_url: 'https://utube-clone-using-react.web.app/',
//         github_url: 'https://github.com/PakkiPavan/Youtube-clone-react-app',
//         category: ['react.js', 'redux', 'firebase', 'Youtube-API']
//     },
//     {
//         name: 'Mastermind Game',
//         image: 'Mastermind.JPG',
//         deployed_url: 'https://mastermind-game.netlify.app/',
//         github_url: 'https://github.com/PakkiPavan/MastermindGame',
//         category: ['react.js']
//     },
//     {
//         name: 'Linkedin Clone',
//         image: 'Linkedin.JPG',
//         deployed_url: 'https://linkedin-clone-using-react.web.app/',
//         github_url: 'https://github.com/PakkiPavan/Linkedin-Clone-using-React',
//         category: ['react.js', 'redux', 'firebase']
//     },
//     {
//         name: 'Portfolio',
//         image: 'Portfolio.JPG',
//         deployed_url: 'https://pavan-pakki.netlify.app/',
//         github_url: 'https://github.com/PakkiPavan/Portfolio',
//         category: ['react.js']
//     },
//     {
//         name: 'Login/SignUp Forms',
//         image: 'Login.JPG',
//         deployed_url: 'https://login-signup-form.netlify.app/',
//         github_url: 'https://github.com/PakkiPavan/Login-Signup-Forms',
//         category: ['HTML', 'CSS', 'HTML/CSS']
//     },
//     {
//         name: '3D Effect',
//         image: '3DEffect.JPG',
//         deployed_url: 'https://3d-rotation.netlify.app/',
//         github_url: 'https://github.com/PakkiPavan/3D-Effect',
//         category: ['HTML', 'CSS', 'HTML/CSS']
//     },
//     {
//         name: 'User Authentication',
//         image: 'Login.JPG',
//         deployed_url: 'https://mern-app-v1.herokuapp.com/',
//         github_url: 'https://github.com/PakkiPavan/MERN-App',
//         category: ['node.js', 'mongoDB', 'react.js', 'heroku']
//     }
// ]

export default projectsData;